// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const PlusIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M9 4H6V1C6 0.45 5.55 0 5 0C4.45 0 4 0.45 4 1V4H1C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6H4V9C4 9.55 4.45 10 5 10C5.55 10 6 9.55 6 9V6H9C9.55 6 10 5.55 10 5C10 4.45 9.55 4 9 4Z" />
        </svg>
      )
    }
  </Icon>
);

export default PlusIcon;
